import { render, staticRenderFns } from "./BiotechHeader.vue?vue&type=template&id=20daf36b&scoped=true"
import script from "./BiotechHeader.vue?vue&type=script&lang=js"
export * from "./BiotechHeader.vue?vue&type=script&lang=js"
import style0 from "./BiotechHeader.vue?vue&type=style&index=0&id=20daf36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20daf36b",
  null
  
)

export default component.exports